import { SkeletonBox } from '@billy/design-system/src/components/SkeletonBox/styles'
import { ReactElement } from 'react'

import {
  PaymentMethodsModal,
  usePredefinedPaymentMethodsValues,
} from '@features/invoicingSettings/modules/paymentsAndReminders'
import { usePayNowStatus } from '@features/paynow/hooks/usePayNowStatus'

import { ModalId } from '../../../../../../../../../../../../enums/modalId'
import { PaymentMethodsBanner } from './elements/PaymentMethodsBanner'
import { PaymentMethodsList } from './elements/PaymentMethodsList'

export const PaymentMethods = (): ReactElement => {
  const { isLoading, predefinedPaymentMethodsValues } = usePredefinedPaymentMethodsValues()

  const { isConnected: isStripeConnected, isLoading: isStripeConnectedLoading } = usePayNowStatus()

  const hasPredefinedPaymentMethods = Object.values(predefinedPaymentMethodsValues).some(Boolean)
  const shouldDisplayPaymentMethodsList = hasPredefinedPaymentMethods || isStripeConnected

  if (isLoading || isStripeConnectedLoading) {
    return <SkeletonBox fullWidth />
  }

  return (
    <>
      {shouldDisplayPaymentMethodsList ? <PaymentMethodsList /> : <PaymentMethodsBanner />}
      <PaymentMethodsModal id={ModalId.InvoiceEditorPaymentMethodsModal} />
    </>
  )
}
